import React from 'react';
import { AuthBrandPanel } from './AuthBrandPanel';
import '../styles/auth-design.css';

export function AuthShell({ children, className = '' }) {
  return (
    <div className={`auth-shell ${className}`.trim()}>
      <AuthBrandPanel />
      <div className="auth-shell__panel">{children}</div>
    </div>
  );
}
